var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeIconShow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 13,
    viewBox: "0 0 18 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 6.62465C1.41547 3.0328 4.9091 0.488281 9.00002 0.488281C13.095 0.488281 16.5846 3.0328 18 6.62465C16.5846 10.2165 13.095 12.761 9.00002 12.761C4.9091 12.761 1.41547 10.2165 0 6.62465ZM4.90909 6.62461C4.90909 8.88279 6.74184 10.7155 9.00002 10.7155C11.2582 10.7155 13.0909 8.88283 13.0909 6.62465C13.0909 4.36647 11.2582 2.53372 9.00002 2.53372C6.74184 2.53372 4.90909 4.36643 4.90909 6.62461ZM6.5459 6.62447C6.5459 5.27036 7.64634 4.16992 9.00045 4.16992C10.3545 4.16992 11.455 5.27036 11.455 6.62447C11.455 7.97857 10.3545 9.07901 9.00045 9.07901C7.64634 9.07901 6.5459 7.97857 6.5459 6.62447Z",
    fill: "#AAAAAA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIconShow);
export default __webpack_public_path__ + "static/media/eye-icon-show.c520d66ecd3b20630af0061e50e9b5ab.svg";
export { ForwardRef as ReactComponent };